import React from 'react';
import PropTypes from 'prop-types';
import CurrencySelector from './CurrencySelector';
import LanguageSelector from './LanguageSelector';
import Wrapper from './Wrapper';
import { headerShapes } from 'Constants/PropTypes';

/**
 * User Preferences
 *
 * Allows the user to select the language and currency,
 * has two visible ways, one for mobile and one for desktop, controlled by the wrapper
 */

function UserPreferences(props) {
    const {
        availableLanguages, defaultLanguage, currentLanguage, onChangeLanguage,
        availableCurrencies, defaultCurrency, currentCurrency, onChangeCurrency,
        showCurrencySelector, showLanguageSelector, currencyDisplay,
    } = props;
    const renderLanguageSelector = showLanguageSelector && availableLanguages?.length > 1;
    const renderCurrencySelector = showCurrencySelector && Object.keys(availableCurrencies).length > 1;
    return (
        <UserPreferences.Wrapper>
            { renderLanguageSelector ? <LanguageSelector
                defaultLanguage={defaultLanguage}
                currentLanguage={currentLanguage}
                availableLanguages={availableLanguages}
                onChangeLanguage={onChangeLanguage}
            /> : null}
            { renderCurrencySelector ? <CurrencySelector
                defaultCurrency={defaultCurrency}
                currentCurrency={currentCurrency}
                availableCurrencies={availableCurrencies}
                onChangeCurrency={onChangeCurrency}
                displaySymbol={currencyDisplay === 'symbol'}
            /> : null}
        </UserPreferences.Wrapper>
    );
}

UserPreferences.Wrapper = Wrapper;

UserPreferences.defaultProps = {
    showCurrencySelector : false,
    showLanguageSelector : false,
    defaultCurrency      : { code: '', symbol: '' },
};

UserPreferences.propTypes = {
    availableLanguages   : PropTypes.arrayOf(PropTypes.string).isRequired,
    defaultLanguage      : PropTypes.string.isRequired,
    currentLanguage      : PropTypes.string.isRequired,
    currencyDisplay      : PropTypes.string.isRequired,
    onChangeLanguage     : PropTypes.func.isRequired,
    availableCurrencies  : PropTypes.objectOf(PropTypes.shape(headerShapes.currencyShape)).isRequired,
    defaultCurrency      : PropTypes.shape(headerShapes.currencyShape),
    currentCurrency      : PropTypes.shape(headerShapes.currencyShape).isRequired,
    onChangeCurrency     : PropTypes.func.isRequired,
    showCurrencySelector : PropTypes.bool,
    showLanguageSelector : PropTypes.bool,
};

export default UserPreferences;
